import { Tab, Tabs } from '@heroui/react';
import React, { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Adresy dwóch widoków generatora. Edytor ma własny, bez zakładek. */
export const GENERATOR_ROUTES = {
  new: '/ads-generator',
  creatives: '/ads-generator/creatives',
  editor: '/ads-generator/editor',
  settings: '/ads-generator/settings',
} as const;

/**
 * Przełącznik widoków. Zakładki zmieniają ADRES, a nie stan komponentu, więc
 * listę kreacji da się podlinkować, otworzyć w nowej karcie i wrócić do niej
 * przyciskiem wstecz.
 */
export const GeneratorTabs: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const selected = pathname.startsWith(GENERATOR_ROUTES.creatives) ? 'creatives' : 'new';

  return (
    <Tabs
      size="sm"
      radius="sm"
      aria-label="Widok generatora"
      selectedKey={selected}
      onSelectionChange={(key) => navigate(
        key === 'creatives' ? GENERATOR_ROUTES.creatives : GENERATOR_ROUTES.new,
      )}
    >
      <Tab key="new" title="Nowa kreacja" />
      <Tab key="creatives" title="Moje kreacje" />
    </Tabs>
  );
};
